/**
 * Phase 4 — dated, case-linked reminders. Today the only type is the CDL Legal claim
 * (Lloyd, Jul 21 2026: "Trigger on the first pre-trial is fine. And escalate if no one acts.").
 */
export interface CaseReminderDto {
  CaseReminder_guid: string;
  CaseReminder_Type: string;
  CaseReminder_DueAt: string;
  CaseReminder_State: string;
  CaseReminder_EscalatedAt: string | null;
  CaseReminder_ResolvedAt: string | null;
  CaseReminder_ResolvedByName: string | null;
  title: string;
  body: string;
  Ticket_guid: string | null;
  Ticket_Number: string | null;
  clientName: string | null;
}

class CaseReminderApi {
  private static host(): string {
    return process.env.API_HOST?.trim() || window.location.origin;
  }

  /** Everything awaiting action, most overdue first. */
  static async listOpen(): Promise<CaseReminderDto[]> {
    const response = await fetch(`${CaseReminderApi.host()}/api/v1/manager/case-reminders`, {
      method: 'GET',
      credentials: 'include',
    });
    if (!response.ok) throw new Error('Failed to load reminders');
    return response.json();
  }

  /** Reminders on one case, resolved ones included. */
  static async listForTicket(ticketGuid: string): Promise<CaseReminderDto[]> {
    const response = await fetch(
      `${CaseReminderApi.host()}/api/v1/manager/ticket/${ticketGuid}/case-reminders`,
      { method: 'GET', credentials: 'include' },
    );
    if (!response.ok) throw new Error('Failed to load reminders for this case');
    return response.json();
  }

  /** Mark the claim filed — the only thing that takes a reminder out of the list. */
  static async resolve(reminderGuid: string): Promise<CaseReminderDto> {
    const response = await fetch(
      `${CaseReminderApi.host()}/api/v1/manager/case-reminder/${reminderGuid}/resolve`,
      { method: 'POST', credentials: 'include' },
    );
    if (!response.ok) throw new Error('Failed to update the reminder');
    return response.json();
  }
}

export default CaseReminderApi;
